export default __webpack_public_path__ + "static/media/cg_perspective.b9a90dfe.jpg";